sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Projects = BlockBase.extend("com.reply.leaviosa.blocks.admin.Projects", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.admin.Projects",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.admin.Projects",
					type: ViewType.XML
				}
			}
		}
	});

	return Projects;
});